export const initialState = {
    loading: true,
    error: false,
    data: null,
    isFetchSuccess: false
};

export const urls = {
    getReservationDetailSeller: id => `/api/reservations/seller/${id}`
};

export const TYPE = {
    getReservationDetailSeller: 'GET_RESERVATION_DETAIL_SELLER'
};

export default (state = initialState, action) => {
    switch (action.type) {
        case `RECEIVE_${TYPE.getReservationDetailSeller}`:
            return {
                ...state,
                loading: false,
                data: action.data,
                error: false,
                isFetchSuccess: true
            };
        case `ERROR_${TYPE.getReservationDetailSeller}`:
            return {
                ...state,
                loading: false,
                error: true,
                data: null
            };
        case `REQUEST_${TYPE.getReservationDetailSeller}`:
            return {
                ...state,
                error: false,
                loading: true,
                isFetchSuccess: false
            };
        default:
            return state;
    }
};
